import { BottomSheet } from '../ui/BottomSheet';

export function IOSPushModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className="px-6 pb-8 pt-2">
        <h3 className="text-lg font-medium text-text-primary">Enable iOS push notifications</h3>
        <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm text-text-muted">
          <li>Tap the <strong>Share</strong> icon in Safari</li>
          <li>Choose <strong>Add to Home Screen</strong></li>
          <li>Open Nudge from the home screen icon</li>
          <li>Return to Settings → tap <strong>Push notifications</strong> again</li>
        </ol>
        <p className="mt-3 text-xs text-text-muted">
          iOS only allows web push when an app is installed to the home screen. This is an Apple platform requirement.
        </p>
        <button onClick={onClose} className="mt-6 w-full rounded-xl bg-sage py-3 text-sm font-medium text-white">
          Got it
        </button>
      </div>
    </BottomSheet>
  );
}
